import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import { FadeUp, Overline } from "./Reveal";

const TEASERS = [
  {
    to: "/story",
    label: "Our Story",
    title: "A different kind of health company",
    text: "Built in the spirit of Karma Sanyas — technology as selfless service, with no investor pressure to put profit ahead of patients.",
    testId: "company-teaser-story",
  },
  {
    to: "/why-anxya",
    label: "Why Anxya",
    title: "Data belongs to patients — not platforms",
    text: "A compliant-by-default, decentralised and data-sovereign approach to healthcare AI, designed to leave the elephants behind.",
    testId: "company-teaser-why",
  },
];

export const CompanyTeasers = () => (
  <section className="py-24 lg:py-32 bg-white border-y border-primary/10" data-testid="company-teasers">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <FadeUp>
        <Overline>The ethos behind Anxya</Overline>
        <h2 className="mt-4 max-w-3xl font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-primary">
          Purpose before profit. Patients before platforms.
        </h2>
      </FadeUp>
      <div className="mt-12 grid gap-4 md:grid-cols-2">
        {TEASERS.map((item, i) => (
          <FadeUp key={item.to} delay={i * 0.08}>
            <Link
              to={item.to}
              data-testid={item.testId}
              className="group flex h-full flex-col justify-between rounded-3xl border border-primary/10 bg-background p-8 lg:p-10 transition-all duration-300 hover:-translate-y-1 hover:border-accent/50 hover:shadow-xl hover:shadow-accent/10"
            >
              <div>
                <p className="text-xs font-bold tracking-[0.25em] uppercase text-accent">{item.label}</p>
                <h3 className="mt-5 font-display text-2xl sm:text-3xl font-medium tracking-tight text-primary">{item.title}</h3>
                <p className="mt-4 text-sm sm:text-base text-muted-foreground leading-relaxed">{item.text}</p>
              </div>
              <span className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-primary group-hover:text-brand-700 transition-colors">
                Read more <ArrowUpRight size={16} weight="bold" className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </span>
            </Link>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
